import React, { forwardRef } from 'react'
import cx from 'classnames'

const Flex = forwardRef(({
  className,
  ...props
}, ref) => {
  const classes = cx(className, 'm-flex')

  return (
    <div
      className={classes}
      ref={ref}
      {...props}
    />
  )
})

export default Flex
